// Product data for MF-Enterprises
// This file contains all product information organized by categories

const products = [
  // ========== OUTDOOR GYM EQUIPMENT (31 items) ==========
  {
    id: "og-1",
    name: "Air Walker",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Air Walker.png",
    description: "Premium outdoor air walker for public parks and fitness areas. Made from high-quality iron with durable powder coating for long-lasting performance in all weather conditions.",
    features: [
      "Smooth gliding motion for low-impact cardiovascular exercise",
      "Strengthens leg muscles and improves coordination",
      "Weather-resistant iron construction with powder coating",
      "Suitable for users of all fitness levels",
      "Maintenance-free design for public installations"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Ground mounting required",
      dimensions: "Standard size for adult users",
      weight_capacity: "150 kg",
      age_group: "14 years and above"
    },
    seo_keywords: "outdoor air walker, park fitness equipment, outdoor gym air walker, public exercise equipment, iron air walker, powder coated fitness equipment, cardio outdoor equipment, MF-Enterprises air walker"
  },
  {
    id: "og-2",
    name: "Shoulder Press",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Shoulder Press.jpg",
    description: "Professional-grade outdoor shoulder press machine designed for upper body strength training in public parks and fitness zones. Built with premium iron and powder coating for maximum durability.",
    features: [
      "Targets deltoid and trapezius muscles for comprehensive shoulder development",
      "Smooth resistance mechanism for safe and effective workouts",
      "Weather-resistant construction for year-round outdoor use",
      "Ergonomic design with comfortable grips",
      "Low maintenance requirements ideal for public installations"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Secure ground mounting required",
      dimensions: "Standard size for adult users",
      weight_capacity: "150 kg",
      age_group: "14 years and above"
    },
    seo_keywords: "outdoor shoulder press, park strength equipment, outdoor gym shoulder machine, public exercise equipment, iron shoulder press, powder coated fitness equipment, upper body outdoor equipment, MF-Enterprises shoulder press"
  },
  {
    id: "og-3",
    name: "Chest Press",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Chest Press.jpg",
    description: "Heavy-duty outdoor chest press machine specifically designed for public fitness areas and parks. Constructed with premium iron and protective powder coating for exceptional durability and resistance to outdoor elements.",
    features: [
      "Effectively targets pectoral muscles, shoulders, and triceps",
      "Balanced resistance for safe and effective chest development",
      "All-weather construction for continuous outdoor use",
      "Ergonomic seat and handle positions for proper exercise form",
      "Minimal maintenance design ideal for public installations"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Concrete foundation mounting required",
      dimensions: "Standard size for adult users",
      weight_capacity: "150 kg",
      age_group: "14 years and above"
    },
    seo_keywords: "outdoor chest press, park strength equipment, outdoor gym chest machine, public exercise equipment, iron chest press, powder coated fitness equipment, pectoral exercise equipment, MF-Enterprises chest press"
  },
  {
    id: "og-4",
    name: "Sky Walker",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Sky Walker.png",
    description: "Premium outdoor sky walker designed for cardiovascular exercise and coordination improvement in public parks and fitness areas. Built with high-quality iron and durable powder coating for long-lasting performance.",
    features: [
      "Smooth gliding motion for effective cardiovascular training",
      "Improves balance, coordination and core strength",
      "Weather-resistant iron construction with powder coating",
      "Suitable for users of all fitness levels",
      "Low maintenance design ideal for public installations"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Ground mounting required",
      dimensions: "Standard size for adult users",
      weight_capacity: "150 kg",
      age_group: "14 years and above"
    },
    seo_keywords: "outdoor sky walker, park fitness equipment, outdoor gym sky walker, public exercise equipment, iron sky walker, powder coated fitness equipment, cardio outdoor equipment, MF-Enterprises sky walker, outdoor fitness, park exercise equipment"
  },
  {
    id: "og-5",
    name: "Shoulder-cum-Chest Press",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Shoulder-cum-Chest Press.jpg",
    description: "Versatile outdoor combination machine that targets both shoulder and chest muscles in one compact unit. Constructed with premium iron and protective powder coating for exceptional durability in all weather conditions.",
    features: [
      "Dual-function design for efficient upper body workouts",
      "Targets pectoral, deltoid, and triceps muscle groups",
      "Weather-resistant construction for year-round outdoor use",
      "Space-saving design ideal for smaller fitness areas",
      "Low maintenance requirements perfect for public installations"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Secure ground mounting required",
      dimensions: "Standard size for adult users",
      weight_capacity: "150 kg",
      age_group: "14 years and above"
    },
    seo_keywords: "outdoor shoulder chest press, combination fitness equipment, dual-function outdoor gym, public exercise equipment, iron fitness machine, powder coated gym equipment, upper body outdoor equipment, MF-Enterprises shoulder chest press, multi-function exercise machine"
  },
  {
    id: "og-6",
    name: "Twister",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Twister.png",
    description: "Professional outdoor twister station designed to improve core strength, flexibility and rotational mobility. Built with high-quality iron and durable powder coating for long-lasting performance in public parks and fitness areas.",
    features: [
      "Rotating platform for effective core and oblique training",
      "Improves spinal mobility and waist flexibility",
      "Weather-resistant iron construction with powder coating",
      "Intuitive design suitable for users of all fitness levels",
      "Minimal maintenance requirements ideal for public installations"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Ground mounting required",
      dimensions: "Standard size for adult users",
      weight_capacity: "150 kg",
      age_group: "14 years and above"
    },
    seo_keywords: "outdoor twister, core training equipment, rotational fitness equipment, public exercise equipment, iron twister, powder coated fitness equipment, waist exercise equipment, MF-Enterprises twister, outdoor fitness, park exercise equipment"
  },
  {
    id: "og-7",
    name: "Shoulder Builder",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Shoulder Builder.png",
    description: "Specialized machine for shoulder muscle development."
  },
  {
    id: "og-8",
    name: "Taichi Spinner",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Taichi Spinner.png",
    description: "Outdoor tai chi spinner for joint mobility and coordination."
  },
  {
    id: "og-9",
    name: "Leg Press",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Leg Press.jpg",
    description: "Outdoor leg press machine for lower body strength."
  },
  {
    id: "og-10",
    name: "Surf Board",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Surf Board.png",
    description: "Outdoor surf board for core stability and balance training."
  },
  {
    id: "og-11",
    name: "Rower",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Rower.jpg",
    description: "Outdoor rowing machine for full-body workouts."
  },
  {
    id: "og-12",
    name: "Rider",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Rider.jpg",
    description: "Outdoor rider machine for lower body and core exercise."
  },
  {
    id: "og-13",
    name: "Pommel Horse",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Pommel Horse.png",
    description: "Outdoor pommel horse for gymnastic-style exercises."
  },
  {
    id: "og-14",
    name: "Standing Twist",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Standing Twist.png",
    description: "Standing twist machine for core and oblique training."
  },
  {
    id: "og-15",
    name: "Bicycle",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Bicycle.png",
    description: "Outdoor stationary bicycle for cardiovascular exercise."
  },
  {
    id: "og-16",
    name: "Back Strengthener",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Back Strengthener.jpg",
    description: "Specialized machine for back muscle development and strength."
  },
  {
    id: "og-17",
    name: "Back Massager",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Back Massager.png",
    description: "Outdoor back massage station for relaxation and recovery."
  },
  {
    id: "og-18",
    name: "Parallel Bar",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Parallel Bar.png",
    description: "Outdoor parallel bars for bodyweight exercises and strength training."
  },
  {
    id: "og-19",
    name: "Cross Trainer",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Cross Trainer.png",
    description: "Outdoor cross trainer for full-body cardio workouts."
  },
  {
    id: "og-20",
    name: "Bench with Fixed Weight",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Bench with Fixed Weight.png",
    description: "Exercise bench with attached weights for strength training."
  },
  {
    id: "og-21",
    name: "Treadmill",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Treadmill.jpg",
    description: "Outdoor treadmill for walking and running exercises."
  },
  {
    id: "og-22",
    name: "Bench with Fixed Dumbbells",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Bench with Fixed Dumbbells.png",
    description: "Exercise bench with attached dumbbells for varied strength exercises."
  },
  {
    id: "og-23",
    name: "Pull Up Bar",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Pull Up Bar.jpg",
    description: "Outdoor pull-up bar for upper body strength development."
  },
  {
    id: "og-24",
    name: "Pole with Fixed Weight",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Pole with Fixed Weight.jpg",
    description: "Vertical pole with attached weights for strength exercises."
  },
  {
    id: "og-25",
    name: "Push Up Bar",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Push Up Bar.jpg",
    description: "Outdoor push-up bars for chest and arm workouts."
  },
  {
    id: "og-26",
    name: "Leg Extension",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Leg Extension.jpg",
    description: "Outdoor leg extension machine for quadriceps training."
  },
  {
    id: "og-27",
    name: "Monkey Bar",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Monkey Bar.png",
    description: "Outdoor monkey bars for upper body and grip strength."
  },
  {
    id: "og-28",
    name: "Twister + Stepper",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Twister+Stepper.png",
    description: "Combination machine with twister and stepper functions."
  },
  {
    id: "og-29",
    name: "ABS Board",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/ABS Board.jpg",
    description: "Specialized board for abdominal muscle exercises."
  },
  {
    id: "og-30",
    name: "Loop Monkey Bar",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Loop Monkey Bar.jpg",
    description: "Loop-style monkey bars for varied grip training."
  },
  {
    id: "og-31",
    name: "Arc Monkey Bar",
    category: "outdoor-gym",
    image: "/images/Out-Door-Gym/Arc Monkey Bar.png",
    description: "Arc-shaped monkey bars for progressive difficulty training."
  },

  // ========== PLAYGROUND EQUIPMENT (34 items) ==========
  // Swings (6)
  {
    id: "pg-1",
    name: "Swing",
    category: "playground",
    subcategory: "swings",
    image: "/images/Playground/Swing.jpg",
    description: "Classic playground swing set made from high-quality iron with durable powder coating. Perfect for parks, schools, and residential areas to provide safe and enjoyable play experiences for children.",
    features: [
      "Sturdy iron frame with weather-resistant powder coating",
      "Comfortable seats with safety features for secure play",
      "Smooth swinging motion for enjoyable playground experience",
      "Designed for long-term outdoor use in all weather conditions",
      "Easy maintenance and cleaning"
    ],
    specifications: {
      material: "High-quality iron with powder coating",
      warranty: "1-year warranty",
      installation: "Secure ground anchoring required",
      dimensions: "Standard size suitable for children",
      weight_capacity: "80 kg per swing",
      age_group: "3-12 years"
    },
    seo_keywords: "playground swing, children's swing set, outdoor playground equipment, iron swing set, powder coated playground equipment, park swing, school playground swing, MF-Enterprises swing"
  },
  {
    id: "pg-2",
    name: "Arc Swing",
    category: "playground",
    subcategory: "swings",
    image: "/images/Playground/Arc Swing.png",
    description: "Arc-shaped swing design for enhanced playground enjoyment."
  },
  {
    id: "pg-3",
    name: "Swing Combo",
    category: "playground",
    subcategory: "swings",
    image: "/images/Playground/Swing Combo.jpeg",
    description: "Combination swing set with multiple swing types."
  },
  {
    id: "pg-4",
    name: "Party Swing",
    category: "playground",
    subcategory: "swings",
    image: "/images/Playground/Party Swing.png",
    description: "Group swing that accommodates multiple children simultaneously."
  },
  {
    id: "pg-5",
    name: "MGR Swing",
    category: "playground",
    subcategory: "swings",
    image: "/images/Playground/Swinging MGR.png",
    description: "Specialized MGR swing design for playground enjoyment."
  },
  {
    id: "pg-6",
    name: "Multilane Swing",
    category: "playground",
    subcategory: "swings",
    image: "/images/Playground/Party Swing.png",
    description: "Multiple lane swing set for group play activities."
  },

  // Merry-Go-Rounds (4)
  {
    id: "pg-7",
    name: "Standing MGR",
    category: "playground",
    subcategory: "merry-go-rounds",
    image: "/images/Playground/Standing MGR.jpg",
    description: "Standing merry-go-round for active playground fun."
  },
  {
    id: "pg-8",
    name: "Bucket MGR",
    category: "playground",
    subcategory: "merry-go-rounds",
    image: "/images/Playground/Bucket MGR.png",
    description: "Bucket-seat merry-go-round for younger children."
  },
  {
    id: "pg-9",
    name: "Seater MGR",
    category: "playground",
    subcategory: "merry-go-rounds",
    image: "/images/Playground/Seater MGR.png",
    description: "Seated merry-go-round for comfortable spinning play."
  },
  {
    id: "pg-10",
    name: "Cycle MGR",
    category: "playground",
    subcategory: "merry-go-rounds",
    image: "/images/Playground/Cycle MGR.jpg",
    description: "Pedal-powered merry-go-round for interactive play."
  },

  // Slides (4)
  {
    id: "pg-11",
    name: "FRP Plain Slide",
    category: "playground",
    subcategory: "slides",
    image: "/images/Playground/FRP Plain Slide.png",
    description: "Premium straight fiberglass reinforced plastic slide designed for playgrounds in parks, schools, and residential areas. Features a smooth sliding surface with safety rails and durable construction for years of enjoyment.",
    features: [
      "High-quality FRP construction for durability and weather resistance",
      "Smooth sliding surface for safe and enjoyable play",
      "Safety rails to prevent falls during use",
      "UV-resistant materials to prevent fading and deterioration",
      "Easy to clean and maintain"
    ],
    specifications: {
      material: "Fiberglass Reinforced Plastic (FRP) with iron supports",
      warranty: "1-year warranty",
      installation: "Secure mounting to platform required",
      dimensions: "Standard length suitable for playground structures",
      weight_capacity: "80 kg",
      age_group: "3-12 years"
    },
    seo_keywords: "FRP playground slide, fiberglass reinforced plastic slide, straight playground slide, outdoor playground equipment, children's slide, park slide, school playground slide, MF-Enterprises slide"
  },
  {
    id: "pg-12",
    name: "FRP Wave Slide",
    category: "playground",
    subcategory: "slides",
    image: "/images/Playground/FRP Wave Slide.jpg",
    description: "Wavy fiberglass reinforced plastic slide for added excitement."
  },
  {
    id: "pg-13",
    name: "Roller Slide",
    category: "playground",
    subcategory: "slides",
    image: "/images/Playground/Roller Slide.png",
    description: "Roller slide with smooth rolling action for unique sliding experience."
  },
  {
    id: "pg-14",
    name: "Spiral Slide",
    category: "playground",
    subcategory: "slides",
    image: "/images/Playground/Spiral Slide.jpg",
    description: "Exciting spiral slide for playground thrills."
  },

  // Seesaws (4)
  {
    id: "pg-15",
    name: "Hanging Seesaw",
    category: "playground",
    subcategory: "seesaws",
    image: "/images/Playground/Hanging Seesaw.png",
    description: "Suspended seesaw design for smooth up and down motion."
  },
  {
    id: "pg-16",
    name: "Seesaw Duo",
    category: "playground",
    subcategory: "seesaws",
    image: "/images/Playground/Seesaw Duo.jpg",
    description: "Two-person seesaw for balanced playground fun."
  },
  {
    id: "pg-17",
    name: "Seesaw Quodrio",
    category: "playground",
    subcategory: "seesaws",
    image: "/images/Playground/Seesaw Quodrio.jpg",
    description: "Four-person seesaw for group balancing activities."
  },
  {
    id: "pg-18",
    name: "Horse Seesaw",
    category: "playground",
    subcategory: "seesaws",
    image: "/images/Playground/Horse Seesaw.png",
    description: "Horse-themed seesaw for imaginative play."
  },

  // Climbers (11)
  {
    id: "pg-19",
    name: "Bow Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Rainbow Climber.png",
    description: "Bow-shaped climbing structure for playground adventures."
  },
  {
    id: "pg-20",
    name: "Octa Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Octa Climber.jpg",
    description: "Octagonal climbing structure for multiple climbing paths."
  },
  {
    id: "pg-21",
    name: "O Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/O Climber.png",
    description: "O-shaped climbing structure for circular climbing challenges."
  },
  {
    id: "pg-22",
    name: "Monkey Loop Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Monkey Loop Climber.jpg",
    description: "Loop-style monkey bars for upper body strength development."
  },
  {
    id: "pg-23",
    name: "Quodrio Loop Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Quodro Loop Climber.png",
    description: "Four-loop climbing structure for varied climbing experiences."
  },
  {
    id: "pg-24",
    name: "Stand-Alone Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Stand Alone Slide.png",
    description: "Independent climbing structure for focused climbing activities."
  },
  {
    id: "pg-25",
    name: "C Loop Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/C Loop Climber.png",
    description: "C-shaped loop climber for creative climbing routes."
  },
  {
    id: "pg-26",
    name: "Monkey Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Monkey Climber.png",
    description: "Traditional monkey bars for swinging and climbing."
  },
  {
    id: "pg-27",
    name: "Rainbow Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Rainbow Climber.jpg",
    description: "Rainbow-shaped climbing arch for colorful playground fun."
  },
  {
    id: "pg-28",
    name: "M Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/M Climber.jpg",
    description: "M-shaped climbing structure for varied climbing challenges."
  },
  {
    id: "pg-29",
    name: "Multilane Climber",
    category: "playground",
    subcategory: "climbers",
    image: "/images/Playground/Multi Line Climber.png",
    description: "Multiple lane climbing structure for group climbing activities."
  },

  // Riders (3)
  {
    id: "pg-30",
    name: "Duck Rider",
    category: "playground",
    subcategory: "riders",
    image: "/images/Playground/Duck Rider.jpg",
    description: "Duck-shaped spring rider for young children."
  },
  {
    id: "pg-31",
    name: "Horse Rider",
    category: "playground",
    subcategory: "riders",
    image: "/images/Playground/Horse Rider.jpg",
    description: "Horse-shaped spring rider for bouncing playground fun."
  },
  {
    id: "pg-32",
    name: "Fish Rider",
    category: "playground",
    subcategory: "riders",
    image: "/images/Playground/Fish Rider.jpg",
    description: "Fish-shaped spring rider for imaginative water-themed play."
  },

  // Play Systems (2)
  {
    id: "pg-33",
    name: "Combination Set",
    category: "playground",
    subcategory: "play-systems",
    image: "/images/Playground/Combination Set playground.jpg",
    description: "Complete playground solution featuring multiple integrated play elements in one comprehensive system. This combination set includes slides, climbers, platforms, and activity panels to create an engaging play environment for children of all ages.",
    features: [
      "All-in-one playground solution with multiple play elements",
      "Includes slides, climbers, platforms, and interactive features",
      "Durable iron construction with weather-resistant powder coating",
      "Promotes physical activity, social interaction, and imaginative play",
      "Space-efficient design ideal for parks, schools, and residential areas"
    ],
    specifications: {
      material: "High-quality iron with powder coating and FRP components",
      warranty: "1-year warranty",
      installation: "Professional installation recommended",
      dimensions: "Customizable based on available space",
      weight_capacity: "Multiple children simultaneously",
      age_group: "3-12 years"
    },
    seo_keywords: "playground combination set, multi-activity playground, playground system, outdoor play structure, children's playground equipment, park playground, school playground equipment, MF-Enterprises playground"
  },
  {
    id: "pg-34",
    name: "Multiplay",
    category: "playground",
    subcategory: "play-systems",
    image: "/images/Playground/Multiplay.jpg",
    description: "Integrated multiplay system with slides, climbers, and activity panels."
  },

  // ========== GAZEBOS (4 items) ==========
  {
    id: "gz-1",
    name: "Hexagonal Gazebo",
    category: "gazebos",
    image: "/images/Gazebo/Hexagonal Gazebo.webp",
    description: "Hexagonal gazebo for parks and gardens."
  },
  {
    id: "gz-2",
    name: "Square Gazebo",
    category: "gazebos",
    image: "/images/Gazebo/Square Gazebo.jpg",
    description: "Square gazebo for outdoor seating areas."
  },
  {
    id: "gz-3",
    name: "Oval Gazebo",
    category: "gazebos",
    image: "/images/Gazebo/Oval Gazebo.jpg",
    description: "Oval gazebo for elegant outdoor spaces."
  },
  {
    id: "gz-4",
    name: "Pagoda Gazebo",
    category: "gazebos",
    image: "/images/Gazebo/Pagoda Gazebo.jpg",
    description: "Pagoda-style gazebo for decorative garden features."
  },

  // ========== BENCHES (2 items) ==========
  {
    id: "bn-1",
    name: "Cast Iron Bench",
    category: "benches",
    image: "/images/Benches/Cast Iron Bench.webp",
    description: "Durable cast iron bench for parks and gardens."
  },
  {
    id: "bn-2",
    name: "FRP Strip Bench",
    category: "benches",
    image: "/images/Benches/FRP Strip Bench.jpg",
    description: "Fiberglass reinforced plastic strip bench for outdoor seating."
  },

  // ========== DUSTBINS (5 items) ==========
  {
    id: "db-1",
    name: "Dolphin Dustbin",
    category: "dustbins",
    image: "/images/Dustbins/Dolphin Dustbin.webp",
    description: "Fun dolphin-shaped dustbin for children's areas."
  },
  {
    id: "db-2",
    name: "Donald Penguin Dustbin",
    category: "dustbins",
    image: "/images/Dustbins/Donald Penguin Dustbin.png",
    description: "Cute Donald penguin-shaped dustbin for playful waste management."
  },
  {
    id: "db-3",
    name: "Penguin Dustbin",
    category: "dustbins",
    image: "/images/Dustbins/Penguin Dustbin.webp",
    description: "Adorable penguin-shaped dustbin for children's areas."
  },
  {
    id: "db-4",
    name: "Rabbit Dustbin",
    category: "dustbins",
    image: "/images/Dustbins/Rabbit Dustbin.png",
    description: "Cute rabbit-shaped dustbin for playful waste management."
  },
  {
    id: "db-5",
    name: "Small Penguin Dustbin",
    category: "dustbins",
    image: "/images/Dustbins/Small Penguin Dustbin.jpg",
    description: "Compact penguin-shaped dustbin for smaller spaces."
  }
];

export default products;
